import { collectibleCrudConfig, type Collectible } from '@/config/objects/collectibles';
import {
  CrudListView,
  type CrudConfig,
  type CrudListHeaderAction,
} from '@startupquickstart/frontend';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface CollectiblesListProps {
  config?: CrudConfig<Collectible>;
  defaultWhere?: Record<string, unknown>;
  onItemClick?: (collectible: Collectible) => void;
  className?: string;
  baseUrl?: string;
  headerActions?: CrudListHeaderAction[];
  breadcrumbs?: Array<{ label: string; href?: string; current?: boolean }>;
}

export function CollectiblesList({
  config,
  baseUrl = '/collectibles',
  defaultWhere,
  onItemClick,
  className,
  headerActions,
  breadcrumbs,
}: CollectiblesListProps) {
  const navigate = useNavigate();

  const _onItemClick = useCallback(
    (collectible: Collectible) => {
      if (onItemClick) {
        onItemClick(collectible);
      } else {
        navigate(`/collectibles/${collectible.id}`);
      }
    },
    [navigate, onItemClick],
  );

  return (
    <div className={className}>
      <CrudListView
        config={config || collectibleCrudConfig}
        baseUrl={baseUrl}
        onItemClick={_onItemClick}
        defaultWhere={defaultWhere}
        headerActions={headerActions}
        breadcrumbs={breadcrumbs}
        getValueFromItem={(c: Collectible) => c.id}
        getLabelFromItem={(c: Collectible) => c.name}
      />
    </div>
  );
}
